export { default } from "./FiltersAsTabs";
